import comp from "./Benchmark";
export default comp;
